import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Logo = ({ size = 'default' }) => {
  const isLarge = size === 'large';
  
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_better-site-13/artifacts/yrzg18jb_WhatsApp_Image_2026-02-10_at_18.35.57__1_-removebg-preview.png" 
      alt="ProAct AI" 
      className={`${isLarge ? 'h-20' : 'h-[68px]'} w-auto object-contain`}
    />
  );
};

const navItems = [
  { path: '/solutions', label: 'Solutions' },
  { path: '/how-it-works', label: 'How It Works' },
  { path: '/case-studies', label: 'Client Outcomes' },
  { path: '/partners', label: 'Partners' },
  { path: '/about', label: 'About' },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header 
      data-testid="header" 
      className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-border/50"
    >
      <div className="container-custom h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex-shrink-0">
          <Logo />
        </Link>
        
        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <NavLink 
              key={item.path}
              to={item.path} 
              data-testid={`nav-${item.path.slice(1)}`}
              className={({ isActive }) => 
                `text-sm font-medium transition-colors hover:text-primary ${
                  isActive ? 'text-primary' : 'text-muted-foreground'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        
        <div className="flex items-center space-x-4">
          <Link 
            to="/contact" 
            data-testid="header-cta"
            className="hidden sm:inline-flex bg-primary text-primary-foreground px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-primary/90 transition-all shadow-sm hover:shadow-md"
          >
            Request Demo
          </Link>
          
          <button 
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-foreground hover:bg-secondary rounded-lg transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div 
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t border-border"
          >
            <nav className="container-custom py-4 space-y-2">
              {navItems.map((item) => (
                <NavLink 
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={({ isActive }) => 
                    `block py-2 px-4 rounded-lg text-sm font-medium transition-colors ${
                      isActive ? 'bg-primary/10 text-primary' : 'text-foreground hover:bg-secondary'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <Link 
                to="/contact"
                onClick={() => setMobileMenuOpen(false)}
                className="block py-3 px-4 bg-primary text-primary-foreground rounded-lg text-sm font-semibold text-center mt-4"
              >
                Request Demo
              </Link>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
